import PropTypes from 'prop-types'
import React from 'react'

import Text from 'components/common/Text'

import { Wrapper } from './styles'

const Badge = ({ customCss, count, children }) => {
    return (
        <Wrapper css={customCss} className="badge">
            <Text className="badge__count">{children || count}</Text>
        </Wrapper>
    )
}

Badge.propTypes = {
    customCss: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

Badge.defaultProps = {
    customCss: '',
    count: 0,
}

export default Badge
